

(function ($) {
  ///////////////////////////////////////////////////////////////////////////
  //move image to background 1.0
  ///////////////////////////////////////////////////////////////////////////
  //
  //  '.yourClass' all images inside parent will be put on the background-image
  //  css property of their direct parent
  /////////////////////////////////////////////////////////
  //                                                    
  //  $('.yourClass').moveImageToBg({          
  //      //destroyBelow: "600", //default  0            
  //      //bgType: "cover",  // default cover                  
  //      //bgRepeat: "no-repeat", //default no-repeat               
  //      //bgPosition: "center"   //default center                         
  //  });                                                
  //                                                     
  /////////////////////////////////////////////////////////
  //

  $.fn.moveImageToBg = function (options) {

    var settings = $.extend({
      destroyBelow: " ",
      bgType: "cover",
      bgRepeat: "no-repeat",
      bgPosition: "center"
    }, options)

    return this.each(function (e) {
      var elem_parent = $(this);


      function moveThatImage() {

        if (theWindow.width() > settings.destroyBelow) {
          elem_parent.find('img').each(function () {

            var images = $(this).prop('src');
            var images_height = $(this).height();
            var img_parent = $(this).parent();

            function moveImage() {
              $(img_parent).css('background-image', 'url(' + images + ')');
              // $(img_parent).css('height', images_height);
              $(img_parent).css('background-size', settings.bgType);
              $(img_parent).css('background-position', settings.bgPosition);
              $(img_parent).css('background-repeat', settings.bgRepeat);
            }

            // console.log(elem_parent);
            // console.log(images);
            // console.log(img_parent);


            // $(img_parent).css('opacity', '0');
            // $(img_parent).animate({
            //     opacity: 1
            //   }, 200);


            moveImage();
          });
        } else {
          elem_parent.find('img').parent().css('background-image', 'none');
          elem_parent.find('img').css('display', 'block');
        }
      }


      theWindow.on('window:resize', moveThatImage);
      moveThatImage();
    })

  }

  ///////////////////////////////////////////////////////////////////////////
  //move image to background end 1.0
  ///////////////////////////////////////////////////////////////////////////



})(jQuery); // or even jQuery.noConflict()